import React, { useState } from "react";
import { FaLock, FaMinus, FaPlus, FaServer, FaShieldAlt, FaFileMedicalAlt, FaGlobe, FaLaptopCode, FaChartBar, FaHistory, FaSyncAlt, FaUserSecret, FaFileContract, FaDatabase, FaUserCheck, FaClipboardCheck, FaSignature, FaRegFileAlt, FaLaptopMedical } from "react-icons/fa";
import { AiOutlineSafetyCertificate, } from "react-icons/ai";
import { MdSecurity, MdGppGood, MdVerified, MdOutlineUpdate } from "react-icons/md";
import { FaUsersCog, FaUserShield, FaHandshake, FaRegLightbulb, FaRegCheckCircle } from "react-icons/fa";
import Medpalm from "../../../assests/Healthsoftware/consent.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services =[
    {
        "title": "Healthcare Interoperability Strategy Development",
        "description": 
            "Develop a comprehensive strategy to enhance healthcare data exchange and interoperability between diverse systems. This includes identifying key integration challenges, optimizing workflows, and implementing standardized data-sharing protocols. The strategy ensures accelerated client onboarding, reduces integration costs, and maintains full HIPAA compliance, enabling secure, scalable, and efficient operations across healthcare networks."
    },
    {
        "title": "Healthcare Interoperability Roadmapping",
        "description": 
            "Create a structured and phased roadmap to achieve seamless interoperability in healthcare environments. Define clear milestones, prioritize technology adoption, and establish best practices to align with industry standards like FHIR and HL7. The roadmap ensures a strategic approach to integrating electronic health records (EHRs), patient portals, and other critical healthcare systems, ultimately enhancing care coordination and operational efficiency."
    },
    {
        "title": "Healthcare Data Mapping and Workflow Documentation",
        "description": 
            "Improve data accuracy and system interactions by implementing structured data mapping techniques that standardize information flow across healthcare applications. Document workflows comprehensively to ensure optimized data exchange, reduce manual errors, and enhance accessibility for healthcare professionals. This approach minimizes integration challenges and ensures smooth communication between disparate systems."
    },
    {
        "title": "Healthcare Interoperability Training and Education",
        "description": 
            "Empower healthcare professionals, IT teams, and administrators with expert training on interoperability standards such as FHIR, HL7, and DICOM. Training sessions focus on compliance requirements, implementation best practices, and real-world use cases to facilitate seamless data integration. This initiative ensures that organizations can effectively manage interoperability challenges while maintaining regulatory adherence and data security."
    },
    {
        "title": "EHR Integration Planning",
        "description": 
            "Develop a strategic plan to seamlessly integrate Electronic Health Record (EHR) systems with existing healthcare infrastructures. Utilize industry-standard protocols like FHIR and HL7 to enable secure, scalable, and real-time data exchange. This planning process ensures improved interoperability between hospitals, clinics, insurers, and third-party applications, facilitating better patient care and streamlined administrative operations."
    }
]


const features = [
    {
        text: "EHR & Health IT Integration – Seamless integration of consent management with Electronic Health Records (EHR) and Health IT systems, ensuring smooth data flow and compliance across platforms.",
        icon: <FaClipboardCheck className="text-[#2a627a] text-xl" />,
    },
    {
        text: "Blockchain-Based Consent Management – Use of blockchain technology for secure, immutable consent tracking and storage, enhancing transparency and reducing fraud.",
        icon: <MdGppGood className="text-[#2a627a] text-xl" />,
    },
    {
        text: "Automated Consent Collection – Automated systems to collect and manage consent electronically, reducing errors and ensuring efficient handling of patient data.",
        icon: <FaSignature className="text-[#2a627a] text-xl" />,
    },
    {
        text: "Customizable Consent Forms – Develop customizable consent forms to meet specific regulatory and organizational needs, ensuring a flexible approach to consent management.",
        icon: <MdVerified className="text-[#2a627a] text-xl" />,
    },
    {
        text: "Consent Audit Trails – Maintain detailed audit trails for every consent decision, ensuring complete transparency and providing documentation for regulatory inspections.",
        icon: <FaRegFileAlt className="text-[#2a627a] text-xl" />,
    },
    // {
    //     text: "Automated Consent Expiry & Renewals – Set reminders and automate consent renewal processes.",
    //     icon: <MdOutlineUpdate className="text-[#2a627a] text-xl" />,
    // },
    // {
    //     text: "Integration with EHR & Health Systems – Seamlessly sync consent data across healthcare platforms.",
    //     icon: <FaLaptopMedical className="text-[#2a627a] text-xl" />,
    // },
    // {
    //     text: "Role-Based Access Control – Restrict access to sensitive data based on user roles.",
    //     icon: <FaUserShield className="text-[#2a627a] text-xl" />,
    // },
];

const benefits = [
    { text: "Patients can easily manage and update their consent preferences, leading to better engagement with healthcare services and improving trust.", icon: <FaUserShield className="text-[#2a627a] text-xl" /> },
    { text: "Ensure compliance with healthcare privacy regulations such as HIPAA, GDPR, and other regional laws, reducing the risk of legal complications.", icon: <FaHandshake className="text-[#2a627a] text-xl" /> },
    { text: "By automating consent collection and tracking, healthcare organizations can streamline their data management processes, reducing administrative burden and errors.", icon: <FaRegLightbulb className="text-[#2a627a] text-xl" /> },
    { text: "Consent management systems ensure that patient data is only shared with authorized parties, enhancing data security and protecting patient privacy.", icon: <MdSecurity className="text-[#2a627a] text-xl" /> },
    { text: "Automated tracking and reporting ensure that healthcare organizations can easily produce consent documentation for audits, inspections, and regulatory reviews..", icon: <AiOutlineSafetyCertificate className="text-[#2a627a] text-xl" /> },
    // { text: "Facilitates seamless interoperability with healthcare systems.", icon: <FaRegCheckCircle className="text-[#2a627a] text-xl" /> },
];

const consentItems = [
    { icon: <FaUserShield />, text: "Collects and manages patient consent for the collection, sharing, and usage of their healthcare data, ensuring compliance with privacy regulations." },
    { icon: <FaClipboardCheck />, text: "Manages patient consent for participation in clinical trials and research studies, ensuring ethical standards are met." },
    { icon: <FaLock />, text: "Obtains consent for third-party access to patient data, ensuring that data sharing is transparent and secure." },
    { icon: <FaUserCheck />, text: "Manages patient consent for the use of digital health technologies, including wearables, telemedicine platforms, and mobile health applications." },
    { icon: <FaDatabase />, text: "Tracks and records consent status and history for each patient, enabling accurate audits and ensuring compliance during inspections or reviews." },
    { icon: <FaFileContract />, text: "Develops and maintains systems for automating the collection, storage, and updating of patient consent forms and agreements." },
    { icon: <FaUserSecret />, text: "Ensures that consent management is integrated across multiple healthcare systems, improving interoperability and data security." },
    { icon: <FaSyncAlt />, text: "Provides solutions that ensure consent processes meet international healthcare regulations, such as GDPR, HIPAA, and other regional standards." },
    // { icon: <FaHistory />, text: "Maintains a detailed audit trail of all consent activities for compliance checks." },
    // { icon: <FaServer />, text: "Supports consent management across web, mobile, APIs, and enterprise systems." },
    // { icon: <FaChartBar />, text: "Provides analytics and reports on consent usage and trends." },
    // { icon: <FaShieldAlt />, text: "Adopts frameworks like FHIR in healthcare to maintain standardized consent records." },
    // { icon: <FaFileMedicalAlt />, text: "Enhances data accessibility in healthcare while ensuring patient confidentiality." },
    // { icon: <FaGlobe />, text: "Facilitates cross-border data transfers while maintaining regional compliance." },
    // { icon: <FaLaptopCode />, text: "Integrates with various third-party applications and APIs for seamless interoperability." },
    // { icon: <FaUsersCog />, text: "Manages consent settings for multiple users in enterprise environments." }
];

const ConsentManagement = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 ">Consent Management   </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        It ensures compliance with privacy regulations like HIPAA, GDPR, and CCPA by allowing users to manage their data-sharing preferences
                    </p>
                </div>

                {/* What is Consent? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-2xl hover:shadow-2xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]">What is Consent Management?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                            Consent Management is the process of collecting, tracking, and managing user permissions regarding their personal data usage. It allows users to grant, revoke, or modify their consent for data processing, ensuring transparency and compliance with privacy laws.
                        </p>
                    </div>
                </section>

                {/* Role of Consent Management */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 ">
                        Role of Consent Management
                    </h2>

                    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {consentItems.map((item, index) => (
                            <motion.div
                                key={index}
                                className="relative z-10 bg-gray-300 bg-opacity-70 hover:bg-gray-300 text-gray-800 p-6 rounded-xl shadow-lg transition-transform transform hover:scale-105 hover:shadow-2xl"
                                initial={{ opacity: 0, x: -100 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1 }}
                            >
                                <span className="text-[#2a627a] text-lg">{item.icon}</span>
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 ">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="relative bg-gray-300 bg-opacity-70 hover:bg-gray-300 text-gray-800 p-6 rounded-xl shadow-lg transition-transform transform hover:scale-105 hover:shadow-2xl flex flex-col items-center text-center"
                                initial={{ opacity: 0, x: 200 }}
                                whileInView={{ opacity: 1, x: -10 }}
                                transition={{ duration: 1 }}
                            // viewport={{ once: true }}
                            >
                                <span className="text-[#2a627a] text-lg">{item.icon}</span>
                                <span className="text-gray-800 text-sm font-medium mt-3">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-bg-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>
                               <span className="text-[#2a627a] text-lg">{item.icon}</span>
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-bg-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default ConsentManagement;
